import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 13h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 17h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 13h2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 17h2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileSpreadsheet";
const FileSpreadsheet = memo(themed(Icon));
export {
  FileSpreadsheet
};
//# sourceMappingURL=file-spreadsheet.js.map
